<template>
	<div class="l-header-wrap" v-bind:class="{ 'is-active': headerFixed }">
		<!-- <div class="l-header-wrap" v-o:child-event="headerFixed"> -->
		<div class="l-header">
			<!-- <a href="/"><strong class="ci">CREATIVE XEOGEN</strong></a> -->
			<router-link to="/main"
				><strong class="ci">CREATIVE XEOGEN</strong></router-link
			>
			<button
				class="btn-sidemenu"
				v-bind:class="{ 'is-active': showMobileMenu }"
				v-on:click="showMobileMenu = !showMobileMenu"
			>
				<span>Menu 열기</span></button
			><!-- 메뉴 활성화 addClass is-active -->
			<div class="sidemenu">
				<div class="gnb">
					<router-link to="/uiux">UI/UX</router-link>
					<router-link to="/visual-marketing">Visual Marketing</router-link>
					<router-link to="/aboutus">About us</router-link>
					<router-link to="/contact">Contact</router-link>
					<router-link to="/recruit">Recruit</router-link>
				</div>
				<!-- <div class="brochure-download">
                  <strong class="tit">Brochure Download</strong>
                  <div>
                      <a href="/static/brochure/XEOGEN_WebAgency_KOR_210105.pdf" class="btn-download" target="_blank">Web Agency</a>
                      <a href="/static/brochure/XEOGEN_OnlineMarketing_KOR.pdf" class="btn-download" target="_blank">Online Marketing</a>
                  </div>
              </div> -->
				<div class="brochure-download">
					<div>
						<a
							href="/static/brochure/XEOGEN_WebAgency_KOR.pdf"
							class="btn-download"
							target="_blank"
							>Brochure Download</a
						>
					</div>
				</div>
				<div class="address">
					<strong>서울시 강남구 테헤란로 151 역삼하이츠빌딩 패스트파이브 424호</strong>
					FASTFIVE 424 Yeoksam Heights Building, <br />
					151 Teheran-ro, Gangnam-gu, Seoul, Korea
					<div class="tel">
						<a href="tel:02-3218-3500">Tel +82.2.3218.3500</a>
						<span>Fax +82.2.3218.3600</span>
					</div>
				</div>
				<div class="copyright">&copy; XEOGEN,INC. All Rights Reserved.</div>
				<router-link to="/personalInfo" class="personal-info"
					>개인정보 처리방침</router-link
				>
				<!-- <a href="/personalInfo" class="personal-info">개인정보 처리방침</a> -->
				<button
					class="btn-close"
					v-bind:class="{ 'is-active': showMobileMenu }"
					v-on:click="showMobileMenu = !showMobileMenu"
				>
					<span class="a11y-hidden">Menu 닫기</span>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "App",
	data() {
		return {
			showMobileMenu: false,
			showCategory: false,
			headerFixed: false,
			isMain: true,
			showMobileMenu: false,
		};
	},
	mounted: function () {
		//       var $btnSideMenu = $('.btn-sidemenu');
		//    $btnSideMenu
		//    .on('click',function(){
		//        if (!$btnSideMenu.closest('#app').find('>div').hasClass('xg-main')) {
		//            $('.l-wrap').addClass('body-fixed');
		//        }
		//     });
		//     $('.sidemenu').on('click','.btn-close',function(){
		//         $('.l-wrap').removeClass('body-fixed');
		//     });

		var isMain = this.isMain;
		var mobileMenu = this.showMobileMenu;
		$(".btn-sidemenu").on("click", function () {
			console.log(isMain);
			mobileMenu
				? $(".l-wrap").addClass("body-fixed")
				: $(".l-wrap").removeClass("body-fixed");
		});

		$(".sidemenu").on("click", ".btn-close", function () {
			$(".l-wrap").removeClass("body-fixed");
			mobileMenu = false;
		});
	},
	watch: {
		$route(to, from) {
			if (to.path != from.path) {
				//메인 페이지 여부 확인
				this.isMain =
					this.$route.path.indexOf("main") >= 0 || this.$route.path == ""
						? true
						: false;

				if (this.isMain) {
					$("#app").children("div").addClass("xg-main");
				} else {
					$("#app").children("div").removeClass("xg-main");
				}
				this.sideMenuClose();
				$("html,body").stop().animate({ scrollTop: 0 }, 0);
			}
		},
	},
	methods: {
		sideMenuOpen() {
			$(".btn-sidemenu, .sidemenu .btn-close").addClass("is-active");
			$(".l-wrap").addClass("body-fixed");
			this.showMobileMenu = true;
		},
		sideMenuClose() {
			// $('.btn-sidemenu, .sidemenu .btn-close').removeClass('is-active');
			$(".l-wrap").removeClass("body-fixed");
			this.showMobileMenu = false;
		},
	},
	created() {},
};
</script>


// WEBPACK FOOTER //
// src/components/Header.vue